export default "__VITE_ASSET___FdnUb8B__"